import {
} from '../service/app';

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js